import React, { useState, useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import Popup from "reactjs-popup";
import { useHistory } from "react-router-dom";
import { api } from "../../../services/api";
import ym from "react-yandex-metrika";
import InstallmentsPage from "./picpay/InstallmentsPage";
import CardFormPage from "./picpay/CardFormPage";
import AddCardPage from "./picpay/AddCardPage";
import SuccessPage from "./picpay/SuccessPage";
import { collectDeviceFingerprint, submitChallengeForm, reportChallengeError, collectBrowserData, pollChallengeStatus, observeChallengeMessages } from "./picpay/picpay3dsHelper";
import { declineMessage, cardDeclineNotice, blockedCardMessage } from "./picpay/cardDeclineMessages";

export function PicPayCardFlow({ transactionData, onRequirePersonalInfo }) {
  const history = useHistory();
  const [picpayData, setPicpayData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // Aviso de tentativas restantes do cartao, mostrado abaixo da mensagem de recusa. So aparece
  // junto com um errorMessage, entao limpar o erro ja o esconde.
  const [cardNotice, setCardNotice] = useState("");
  const [open, setOpen] = useState(true);
  const [showCardForm, setShowCardForm] = useState(false);
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [step, setStep] = useState("cards"); // "cards", "installments", "cardForm"
  const [cardsLoading, setCardsLoading] = useState(false); // Adicione este estado
  const [selectedInstallments, setSelectedInstallments] = useState(1); // Novo estado para parcelas
  const [flowType, setFlowType] = useState("");
  const [pendingCardData, setPendingCardData] = useState(null);

  // Adicione esses estados para gerenciar a tela de sucesso
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [receiptLink, setReceiptLink] = useState("");
  const [paymentInfo, setPaymentInfo] = useState({});

  // Adicione este estado no início do componente
  const [hoveredCardId, setHoveredCardId] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteCardId, setDeleteCardId] = useState(null);
  const [deleteCardInfo, setDeleteCardInfo] = useState({
    brand: "",
    last4: "",
  });
  const [deleteCardLoading, setDeleteCardLoading] = useState(false);
  const [collecting3ds, setCollecting3ds] = useState(false);
  const [challengeData, setChallengeData] = useState(null);
  const [challengeCompleting, setChallengeCompleting] = useState(false);
  // Guarda o que a compra precisa depois que o desafio terminar: o handle da sessao 3DS e os
  // dados do cartao/parcelamento escolhidos antes dele.
  const [threeDsContext, setThreeDsContext] = useState(null);
  // Motivo da recusa da autenticacao. Quando preenchido, a compra foi abortada e o comprador ve
  // a tela de recusa, sem caminho de volta para o pagamento.
  const [threeDsRejection, setThreeDsRejection] = useState(null);
  const [threeDsNotice, setThreeDsNotice] = useState("");
  // Cartao bloqueado por recusas: as telas trocam "Continuar"/"Tentar novamente" por "Usar outro
  // cartao", porque tentar de novo com ele nao tem como passar.
  const [cardBlocked, setCardBlocked] = useState(false);

  // Passo 1: Registrar Credenciais na inicialização
  useEffect(() => {
  const init = () => {
    if (window.CheckoutTransparent) {
      window.CheckoutTransparent.setCredentials({
        merchantCredential: "23877777000134",
        transparentToken: "tk_MGVjZTdmNGQtMTUyYy00ZTkwLWI2M2QtYzNjN2I3ODk0NjAwNjgyZWVhNjAtZjNmZS00OTNjLTgwZTEtMTUxZjc5Mjg2MzZm"
      });
    } else {
      // Tenta novamente após 500ms se o SDK ainda não carregou
      setTimeout(init, 500);
    }
  };
  init();
  }, []);

 // Passo 2: Função para obter a bandeira (agora usando Promise para aguardar o sucesso)
  const getPicpayCardBrand = (bin) => {
    return new Promise((resolve, reject) => {
      if (!window.CheckoutTransparent) return reject("PicPay SDK não carregado");
      window.CheckoutTransparent.getCardBrand({
        bin: String(bin).substring(0, 6), // Apenas os primeiros 6 dígitos
        success: (body) => resolve(body.brand),
        error: (body) => reject(body),
      });
    });
  };

  //Passo 3: Função para gerar o token temporário do cartão
  const generatePicpayCardToken = (cardData, brand) => {
    return new Promise((resolve, reject) => {
      if (!window.CheckoutTransparent) return reject("PicPay SDK não carregado");
      // expiryDate vem do CardFormPage já sem formatação: "MMAA" (ex: "0327")
      const expiry = cardData.expiryDate.replace(/\D/g, "");
      const expirationMonth = expiry.slice(0, 2);
      const expirationYear = "20" + expiry.slice(2, 4);
      window.CheckoutTransparent.createTemporaryCard({
        card: {
          number: cardData.cardNumber.replace(/\D/g, ""),
          holderName: cardData.cardHolder,
          expirationMonth,
          expirationYear,
          cvv: cardData.cvv, // CardFormPage usa "cvv", não "ccv"
          brand: brand,
          holderDocument: cardData.document || transactionData.document || "00000000000",
        },
        success: (body) => {

          resolve(body.temporaryToken)
        },
        error: (body) => reject(body),
      });
    });
  };

  // Traduz o motivo tecnico da recusa para o comprador. Esta TENTATIVA termina aqui sob qualquer
  // hipotese: cobrar sem liability shift e exatamente o estado que esta implementacao existe para
  // acabar. O comprador pode comecar outra -- nova sessao, nova autenticacao.
  const abort3ds = (reasonCode, declineData) => {
    const messages = {
      "3ds-authentication-rejected": "Seu banco não autorizou a autenticação desta compra.",
      "3ds-authentication-failed": "Não foi possível concluir a autenticação com seu banco.",
      "3ds-challenge-unavailable": "Seu banco solicitou uma verificação, mas ela não pôde ser exibida.",
      "3ds-session-not-found": "A sessão de pagamento expirou.",
      "3ds-timeout": "O tempo para concluir a verificação do banco expirou.",
    };
    setThreeDsRejection(messages[reasonCode] || "Não foi possível autenticar esta compra com seu banco.");
    // Recusa do banco na verificacao conta para o bloqueio do cartao; o aviso de tentativas
    // restantes vai junto, como numa recusa de pagamento.
    setThreeDsNotice(cardDeclineNotice(declineData));
    setCardBlocked(Boolean(declineData?.cardBlockedUntil));
    setChallengeData(null);
    setThreeDsContext(null);
    setIsLoading(false);
    setCollecting3ds(false);
    setChallengeCompleting(false);
    setStep("3ds-rejected");
  };

  // Saidas de uma recusa ou bloqueio que mantem o comprador na compra.
  const clearDeclineState = () => {
    setErrorMessage("");
    setCardNotice("");
    setCardBlocked(false);
    setThreeDsRejection(null);
    setThreeDsNotice("");
  };

  // Mesmo cartao, nova tentativa: volta para as parcelas, e o "Continuar" abre uma sessao 3DS nova.
  const retrySameCard = () => {
    clearDeclineState();
    setStep("installments");
  };

  const chooseAnotherCard = () => {
    clearDeclineState();
    setStep("cards");
  };

  const handleRedirect = () => {
    setOpen(false);
    history.push({
      pathname: "/",
      search: "",
    });
  };

  const fetchInstallmentsWithBrand = async (brand) => {
    const itemsParam = encodeURIComponent(JSON.stringify(transactionData.items || []));
    let response = await api.get(
      `payment/picpay-installments?items=${itemsParam}&cardBrand=${brand}`
    );

    if (response.data === "unsupported-card-brand" || response.data?.message === "unsupported-card-brand") {
      throw new Error("unsupported-card-brand");
    }

    if (response.data.status === "fail") {
      return (window.location = `/`);
    }

    setPicpayData(response.data);
  };

  const fetchSavedCards = async () => {
    setCardsLoading(true); // Inicia o carregamento
    try {
      const response = await api.get(
        `payment/picpay-user-cards?username=${encodeURIComponent(transactionData.username)}&token=${encodeURIComponent(transactionData.token)}`
      );
      // Mapeia os campos do backend para o formato usado no front
      const mappedCards = response.data.map((card) => ({
        id: card.id,
        last4: card.card_last_digits,
        brand: card.brand,
      }));
      setCards(mappedCards);
      if (mappedCards.length > 0) {
        setSelectedCard(mappedCards[0].id);
        setFlowType("savedCard");
      }
    } catch (error) {
      setCards([]);
    }
    setCardsLoading(false); // Finaliza o carregamento
  };

  async function setup3ds(cardData, cardId, installmentValue) {
    setCollecting3ds(true);
    try {
      const payload = {
        username: transactionData.username,
        token: transactionData.token,
        server: transactionData.server,
        currencyCode: transactionData.currencyCode,
        items: transactionData.items || [],
        picpayInstallment: String(installmentValue),
      };

      if (flowType === "savedCard") {
        const selectedObj = cards.find((c) => c.id === cardId);
        payload.picpayCardId = cardId;
        payload.cardLastDigits = selectedObj?.last4 || "";
        payload.cardBrand = selectedObj?.brand || "";
      }

      let derivedCardData = cardData;
      if (flowType !== "savedCard") {
        // Generate token here so it can be reused in startTransaction without a second SDK call
        const brand = await getPicpayCardBrand(
          cardData.cardNumber.replace(/\D/g, "")
        );
        const temporaryToken = await generatePicpayCardToken(cardData, brand);
        payload.picpayTemporaryCardToken = temporaryToken;
        payload.cardBrand = brand;
        // Bandeira + final identificam o cartao para o bloqueio por recusas. O cartao salvo ja
        // mandava o final; o novo nao, e sem ele o bloqueio nao age.
        payload.cardLastDigits = cardData.cardNumber.replace(/\D/g, "").slice(-4);
        derivedCardData = { ...cardData, _brand: brand, _token: temporaryToken };
      }

      const response = await api.post("payment/picpay-3ds-setup", payload);
      const setup = response.data;

      // Backend determined 3DS is not required for this transaction
      if (setup.skip3ds) {
        return { skip3ds: true, _derivedCardData: derivedCardData };
      }

      // Collect device fingerprint silently in the background
      const collection = await collectDeviceFingerprint(
        setup.accessToken,
        setup.deviceDataCollectionUrl
      );

      // Reporta o desfecho da coleta, inclusive quando nenhuma mensagem chega: e o que
      // permite descobrir, com trafego real, qual formato o iframe do PicPay publica.
      // Fire-and-forget como o resto da telemetria: nao pode somar latencia ao checkout.
      reportChallengeError("device_data_collection_result", {
        username: transactionData.username,
        token: transactionData.token,
        chargeId: setup.chargeId || "",
        detail: JSON.stringify({
          completed: collection?.completed === true,
          messages: collection?.observed || [],
        }),
      });

      // Return both the 3DS auth data and the derived card data to avoid React state race conditions
      return { ...setup, _derivedCardData: derivedCardData };
    } finally {
      setCollecting3ds(false);
    }
  }

  async function startTransaction(cardData, cardId, explicitInstallment, threeDsSetup, cvv) {
    setIsLoading(true);
    setErrorMessage("");
    setCardNotice("");
    setCardBlocked(false);

    const params = {
      username: transactionData.username,
      server: transactionData.server,
      gateway: transactionData.gateway,
      currencyCode: transactionData.currencyCode,
      token: transactionData.token,
      utm_source: transactionData.utm_source,
      utm_medium: transactionData.utm_medium,
      utm_campaign: transactionData.utm_campaign,
      items: transactionData.items || [],
      picpayInstallment: String(explicitInstallment || selectedInstallments),
    };

    if (flowType === "savedCard") {
      const selectedObj = cards.find(c => c.id === cardId);
      params.picpayCardId = cardId;
      params.cardLastDigits = selectedObj ? selectedObj.last4 : "";
      params.cardBrand = selectedObj ? selectedObj.brand : "";
    } else if (flowType === "otherCard") {
      try {
        // Reuse token and brand already derived in setup3ds when available
        const brand = cardData?._brand || await getPicpayCardBrand(cardData.cardNumber.replace(/\D/g, ''));
        const temporaryToken = cardData?._token || await generatePicpayCardToken(cardData, brand);

        params.picpayTemporaryCardToken = temporaryToken;
        params.cardBrand = brand;
        params.cardLastDigits = cardData.cardNumber.replace(/\D/g, "").slice(-4);
        params.cardNumber = cardData.cardNumber;
        params.cardHolder = cardData.cardHolder;
        params.expiryDate = cardData.expiryDate;
        params.cvv = cardData.cvv;
        params.document = cardData.document || "";
        params.email = cardData.email || "";
      } catch (err) {
        console.error("Erro na integração PicPay SDK (Passos 2/3):", err);
        setIsLoading(false);
        return false;
      }
    }

    // Fluxo novo: vai so o handle da sessao. O chargeId e o cardholderAuthenticationId ficam no
    // servidor, e o CVV e exigido pelo endpoint de autorizacao 3DS.
    if (threeDsSetup?.sessionId) {
      params.threeDsSessionId = threeDsSetup.sessionId;
      if (cvv) params.cardCvv = cvv;
    } else if (threeDsSetup?.cardholderAuthenticationId) {
      // Fluxo antigo, preservado para quando a flag do backend estiver desligada.
      params.cardholderAuthenticationId = threeDsSetup.cardholderAuthenticationId;
      params.cardholderAuthenticationReferenceId = threeDsSetup.cardholderAuthenticationReferenceId;
    }

    const isInIFrame = window.location !== window.parent.location;

    try {
      let response = await api.post("payment/purchase", params);

      if (response.data.status === "fail") {
        // Dados pessoais ausentes/inválidos no account_info: em vez de mostrar um erro
        // genérico, redireciona o usuário para completar o cadastro (tela MissingFields).
        // O backend também limpa o campo inválido (wyd.cleanProperty), então a re-checagem
        // de isInformationComplete vai reapresentá-lo corretamente.
        const personalInfoErrors = [
          "incomplete-personal-info",
          "missing-personal-info",
          "invalid-cpf",
          "invalid-fullname",
          "invalid-phone",
        ];
        if (personalInfoErrors.includes(response.data.message) && onRequirePersonalInfo) {
          setIsLoading(false);
          onRequirePersonalInfo();
          return false;
        }

        let msg = "Ocorreu um erro ao processar o pagamento.";
        if (response.data.message === "payment-not-approved") msg = declineMessage(response.data.declineReason);
        else if (response.data.message === "card-temporarily-blocked") msg = blockedCardMessage(response.data);
        else if (response.data.message === "error-processing-payment") msg = "Erro ao processar o pagamento. Tente novamente. Se persistir, entre em contato com o suporte.";
        else if (response.data.message === "payment-canceled") msg = "Pagamento cancelado. Tente novamente. Se persistir, entre em contato com o suporte.";
        else if (response.data.message === "invalid-email") msg = "E-mail inválido.";
        else if (response.data.message === "invalid-cpf") msg = "CPF inválido.";
        else if (response.data.message === "invalid-fullname") msg = "Nome completo inválido.";
        else if (response.data.message === "invalid-phone") msg = "Telefone inválido.";
        else if (response.data.message === "unsupported-card-brand") msg = "Bandeira do cartão não aceita. Utilize Visa, Mastercard, Elo, Amex ou Hipercard.";
        else if (response.data.message === "card-cvv-required") msg = "Informe o código de segurança do cartão.";
        else if (response.data.message === "payment-under-review") msg = "Pagamento em análise. Se um valor tiver sido reservado no seu cartão, ele será liberado. Entre em contato com o suporte antes de tentar de novo.";
        else if (response.data.message) msg = "Erro: " + response.data.message;

        // Recusa por falta de autenticacao valida nao volta para a tela de pagamento: a compra
        // esta abortada e o comprador sai para a home.
        if (response.data.message === "3ds-authentication-required") {
          abort3ds("3ds-authentication-failed");
          return false;
        }

        setErrorMessage(msg);
        if (response.data.message === "payment-not-approved") {
          setCardNotice(cardDeclineNotice(response.data, msg));
        }
        setCardBlocked(
          response.data.message === "card-temporarily-blocked" || Boolean(response.data.cardBlockedUntil)
        );
        setIsLoading(false);
        return false;
      }

      ym("reachGoal", "purchase_request");

      // Em vez de abrir uma nova janela, mostrar a tela de sucesso
      setReceiptLink(response.data.paymentLink);
      setPaymentInfo({
        id: response.data.paymentId || "",
        date: new Date().toLocaleString(),
        installments: selectedInstallments,
      });
      setPaymentSuccess(true);
      setIsLoading(false);
      return true;
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false);
      return false;
    }
  }

  // Adicione a função para excluir o cartão
  const handleDeleteCard = async () => {
    setDeleteCardLoading(true);
    try {
      const response = await api.post("payment/picpay-delete-card", {
        token: transactionData.token,
        username: transactionData.username,
        card_last_digits: deleteCardInfo.last4,
        card_brand: deleteCardInfo.brand,
      });

      if (response.data.status === "success") {
        // Se o cartão excluído era o selecionado, deselecione-o
        if (deleteCardId === selectedCard) {
          setSelectedCard(null);
        }
        // Atualiza a lista de cartões
        fetchSavedCards();
      } else {
        console.error("Erro ao excluir cartão:", response.data.message);
      }
    } catch (error) {
      console.error("Erro ao excluir cartão:", error);
    } finally {
      setDeleteCardLoading(false);
      setShowDeleteConfirmation(false);
      fetchSavedCards();
    }
  };

  useEffect(() => {
    fetchSavedCards();
  }, []);

  // O bloqueio vale para o cartao em que aconteceu. Saindo das telas que o mostram, qualquer outro
  // cartao escolhido comeca liberado -- o backend confere de novo de qualquer forma.
  useEffect(() => {
    if (step !== "installments" && step !== "3ds-rejected") setCardBlocked(false);
  }, [step]);

  useEffect(() => {
    if (step !== "challenge" || !challengeData) return;

    let cancelled = false;

    // Iframe VISIVEL, ao contrario do da coleta de dados: aqui o comprador interage com o banco.
    // A URL e o token vem da resposta do ENROLLMENT, nao da autorizacao.
    const observer = observeChallengeMessages();

    submitChallengeForm(
      challengeData.accessToken,
      challengeData.stepUpUrl,
      "picpay-challenge-iframe"
    );

    pollChallengeStatus({
      username: transactionData.username,
      token: transactionData.token,
      sessionId: challengeData.sessionId,
      intervalSeconds: challengeData.pollIntervalSeconds,
      timeoutSeconds: challengeData.timeoutSeconds,
      shouldStop: () => cancelled,
    }).then(async (result) => {
      const observedMessages = observer.stop();
      if (cancelled) return;

      // Reporta o que apareceu na janela do desafio, qualquer que tenha sido o desfecho. E o
      // unico caminho para descobrirmos o contrato de conclusao do StepUp.
      reportChallengeError("challenge_messages_observed", {
        username: transactionData.username,
        token: transactionData.token,
        merchantChargeId: challengeData.sessionId,
        chargeId: "",
        detail: JSON.stringify({ outcome: result.outcome, messages: observedMessages }),
      });

      if (result.outcome === "authenticated") {
        setChallengeCompleting(true);
        const context = threeDsContext;
        const ok = await startTransaction(
          context?.cardData,
          context?.cardId,
          context?.installment,
          { sessionId: context?.sessionId },
          context?.cvv
        );
        if (cancelled) return;
        setChallengeCompleting(false);
        setChallengeData(null);
        // Em caso de sucesso o render da tela de sucesso tem precedencia; aqui so garantimos que
        // o comprador nao fique preso no modal do desafio se a cobranca falhar.
        if (!ok) setStep("installments");
        return;
      }

      if (result.outcome === "timeout") {
        abort3ds("3ds-timeout");
        return;
      }

      if (result.outcome === "rejected") {
        abort3ds("3ds-authentication-rejected", result.data);
      }
    });

    return () => { cancelled = true; observer.stop(); };
  }, [step, challengeData]); // eslint-disable-line react-hooks/exhaustive-deps

  // Estilos para os cartões
  const cardStyle = (isSelected) => ({
    border: isSelected ? "2px solid #007bff" : "1px solid #ddd",
    borderRadius: "8px",
    padding: "14px",
    marginBottom: "12px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    transition: "all 0.2s ease",
    backgroundColor: isSelected ? "#f8f9ff" : "#fff",
    boxShadow: isSelected
      ? "0 4px 8px rgba(0, 123, 255, 0.15)"
      : "0 1px 3px rgba(0,0,0,0.05)",
    position: "relative",
    overflow: "hidden",
  });

  const renderCardSelection = () => (
    <div className="modal" style={{ maxWidth: "425px", width: "100%" }}>
      <button
        className="close"
        onClick={handleRedirect}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "-10px",
          top: "-10px",
          width: "36px",
          height: "36px",
          fontSize: "24px",
          background: "#D11A2A",
          borderRadius: "18px",
          border: "1px solid #cfcece",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          lineHeight: "normal",
          padding: 0,
        }}
      >
        ×
      </button>
      <img className="logo" src="/img/raidhut.png" alt="raidhut-logo" />
      <h1 className="modal-title">Escolha um cartão</h1>
      <div style={{ margin: "20px 0" }}>
        {cardsLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "30px 0",
            }}
          >
            <ProgressSpinner />
          </div>
        ) : (
          <>
            {cards.map((card) => {
              const isSelected = selectedCard === card.id;
              const isHovered = hoveredCardId === card.id;

              return (
                <div
                  key={card.id}
                  style={cardStyle(isSelected)}
                  onClick={() => {
                    setFlowType("savedCard");
                    setSelectedCard(card.id);
                  }}
                  onMouseEnter={(e) => {
                    setHoveredCardId(card.id); // Registra qual cartão está com mouse em cima
                    if (!isSelected) {
                      e.currentTarget.style.backgroundColor = "#f5f5f5";
                      e.currentTarget.style.boxShadow =
                        "0 2px 5px rgba(0,0,0,0.08)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    setHoveredCardId(null); // Remove quando o mouse sai
                    if (!isSelected) {
                      e.currentTarget.style.backgroundColor = "#fff";
                      e.currentTarget.style.boxShadow =
                        "0 1px 3px rgba(0,0,0,0.05)";
                    }
                  }}
                >
                  {/* Ícone de exclusão - visível apenas quando hoveredCardId === card.id */}
                    {isHovered && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation(); // Evita que o cartão seja selecionado ao clicar no ícone
                          setDeleteCardId(card.id);
                          setDeleteCardInfo({
                            brand: card.brand,
                            last4: card.last4,
                          });
                          setShowDeleteConfirmation(true);
                        }}
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          backgroundColor: "#ffeeee",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          zIndex: 5,
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffdddd";
                          e.currentTarget.style.transform = "scale(1.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffeeee";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#cc0000"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M3 6h18"></path>
                          <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                          <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        </svg>
                      </div>
                    )}

                  {/* Resto do conteúdo do cartão permanece igual */}
                  {isSelected && (
                    <div
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        width: "0",
                        height: "0",
                        borderStyle: "solid",
                        borderWidth: "0 30px 30px 0",
                        borderColor:
                          "transparent #007bff transparent transparent",
                      }}
                    />
                  )}
                  {isSelected && (
                    <div
                      style={{
                        position: "absolute",
                        right: "5px",
                        top: "5px",
                        color: "white",
                        fontSize: "12px",
                      }}
                    >
                      ✓
                    </div>
                  )}
                  <div
                    style={{
                      height: "28px",
                      width: "40px",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={`/img/card_brands/${card.brand || "unknown"}.svg`}
                      alt={card.brand}
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.parentElement.style.backgroundColor = "#f0f0f0";
                        e.target.parentElement.style.fontSize = "10px";
                        e.target.parentElement.style.fontWeight = "bold";
                        e.target.parentElement.innerText = card.brand || "?";
                      }}
                    />
                  </div>
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: isSelected ? "600" : "normal",
                        fontSize: "15px",
                        color: isSelected ? "#007bff" : "#333",
                      }}
                    >
                      •••• {card.last4}
                    </span>
                    {isSelected && (
                      <span
                        style={{
                          color: "#007bff",
                          fontSize: "13px",
                          marginTop: "4px",
                        }}
                      >
                        Selecionado
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
            <button
              className="copy-button"
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => setStep("addCard")}
            >
              + Adicionar novo cartão
            </button>
            <button
              className="copy-button"
              style={{
                width: "100%",
                marginTop: "10px",
                background: "#f0f0f0",
                color: "#333",
              }}
              onClick={() => {
                setFlowType("otherCard");
                setStep("cardForm");
              }}
            >
              Continuar com outro cartão
            </button>
          </>
        )}
      </div>

      {errorMessage && (
        <div style={{ color: "#D11A2A", marginTop: "10px", marginBottom: "10px", textAlign: "center", fontSize: "14px", fontWeight: "bold" }}>
          {errorMessage}
        </div>
      )}

      <button
        className="copy-button"
        style={{ width: "100%", marginTop: "10px" }}
        onClick={async () => {
          if (!selectedCard) return;
          const card = cards.find(c => c.id === selectedCard);
          setFlowType("savedCard");
          setIsLoading(true);
          try {
            await fetchInstallmentsWithBrand(card?.brand || "");
            setStep("installments");
          } catch (err) {
            if (err?.message === "unsupported-card-brand") {
              setErrorMessage("Bandeira do cartão não aceita. Utilize Visa, Mastercard, Elo, Amex ou Hipercard.");
            } else {
              setErrorMessage("Erro ao carregar parcelas. Tente novamente.");
            }
          } finally {
            setIsLoading(false);
          }
        }}
        disabled={!selectedCard || cardsLoading || isLoading}
      >
        {isLoading ? (
          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "6px", width: "100%" }}>
            <ProgressSpinner style={{ width: "16px", height: "16px", margin: 0, flexShrink: 0 }} strokeWidth="8" />
            Carregando...
          </span>
        ) : (
          "Continuar"
        )}
      </button>      {/* Confirmação de exclusão de cartão */}
      {showDeleteConfirmation && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => !deleteCardLoading && setShowDeleteConfirmation(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              width: "80%",
              maxWidth: "350px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            }}
            onClick={(e) => e.stopPropagation()} // Evita que cliques no modal fechem ele
          >
            <h3 style={{ marginTop: 0 }}>Confirmação</h3>
            <p>
              Tem certeza que deseja remover o cartão {deleteCardInfo.brand} de
              final {deleteCardInfo.last4}?
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                style={{
                  marginTop: "16px",
                  marginBottom: "16px",
                  padding: "8px 15px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  background: "#f0f0f0",
                  cursor: "pointer",
                }}
                onClick={() => setShowDeleteConfirmation(false)}
                disabled={deleteCardLoading}
              >
                Cancelar
              </button>
              <button
                className="copy-button"
                style={{ position: "relative", padding: "8px 15px" }}
                onClick={handleDeleteCard}
                disabled={deleteCardLoading}
              >
                {deleteCardLoading ? (
                  <>
                    <ProgressSpinner
                      style={{
                        width: "16px",
                        height: "16px",
                        position: "absolute",
                        left: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                      strokeWidth="8"
                    />
                    <span style={{ marginLeft: "20px" }}>Excluindo...</span>
                  </>
                ) : (
                  "Excluir"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // Etapa 1b: Submissão do formulário de novo cartão → detecta bandeira → busca parcelas
  const handleCardFormSubmit = async (cardData) => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const brand = await getPicpayCardBrand(cardData.cardNumber.replace(/\D/g, ''));
      setPendingCardData(cardData);
      await fetchInstallmentsWithBrand(brand);
      setStep("installments");
    } catch (err) {
      console.error("Erro ao detectar bandeira do cartão:", err);
      if (err?.message === "unsupported-card-brand") {
        setErrorMessage("Bandeira do cartão não aceita. Utilize Visa, Mastercard, Elo, Amex ou Hipercard.");
      } else {
        setErrorMessage("Não foi possível identificar a bandeira do cartão. Verifique o número e tente novamente.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Etapa 2: Seleção de parcelas → setup 3DS → autorização
  const handleInstallmentsContinue = async (installmentValue, cvv) => {
    setSelectedInstallments(installmentValue);
    setIsLoading(true);
    setErrorMessage("");
    setCardNotice("");
    setCardBlocked(false);
    try {
      const cardDataForSetup = flowType === "savedCard" ? null : pendingCardData;
      const cardIdForSetup = flowType === "savedCard" ? selectedCard : null;
      const threeDsSetup = await setup3ds(cardDataForSetup, cardIdForSetup, installmentValue);
      // Use _derivedCardData returned by setup3ds (avoids React state async race for new cards)
      const cardDataForTx = flowType === "savedCard" ? null : (threeDsSetup._derivedCardData || pendingCardData);
      const cardIdForTx = flowType === "savedCard" ? selectedCard : null;
      const effectiveCvv = cvv || cardDataForTx?.cvv;

      // Quem decide se o fluxo 3DS completo esta ativo e o backend, pela flag de configuracao —
      // o front so obedece, como ja fazia com o skip3ds. Sem enrollment, segue o caminho antigo.
      if (!threeDsSetup?.enrollmentRequired) {
        await startTransaction(cardDataForTx, cardIdForTx, installmentValue, threeDsSetup, effectiveCvv);
        return;
      }

      setThreeDsContext({
        sessionId: threeDsSetup.sessionId,
        cardData: cardDataForTx,
        cardId: cardIdForTx,
        installment: installmentValue,
        cvv: effectiveCvv,
      });

      const enrollment = await api.post("payment/picpay-3ds-enrollment", {
        username: transactionData.username,
        token: transactionData.token,
        sessionId: threeDsSetup.sessionId,
        browser: collectBrowserData(),
      });

      const result = enrollment?.data || {};

      if (result.status === "approved") {
        // Autenticado sem desafio (frictionless). Segue direto para a cobranca.
        await startTransaction(cardDataForTx, cardIdForTx, installmentValue, threeDsSetup, effectiveCvv);
        return;
      }

      if (result.status === "challenged") {
        setChallengeData({
          sessionId: threeDsSetup.sessionId,
          stepUpUrl: result.stepUpUrl,
          accessToken: result.accessToken,
          height: result.height,
          width: result.width,
          pollIntervalSeconds: result.pollIntervalSeconds,
          timeoutSeconds: result.timeoutSeconds,
        });
        setStep("challenge");
        setIsLoading(false);
        return;
      }

      abort3ds(result.message, result);
    } catch (err) {
      // Cartao bloqueado e barrado ja no setup, antes de qualquer chamada ao PicPay. O jogador
      // fica nesta tela para escolher outro cartao.
      const data = err?.response?.data;
      if (data?.message === "card-temporarily-blocked") {
        setErrorMessage(blockedCardMessage(data));
        setCardBlocked(true);
        setIsLoading(false);
        return;
      }
      console.error("Erro na compra:", err);
      setErrorMessage("Erro ao processar o pagamento. Tente novamente.");
      setIsLoading(false);
    }
  };

  const calculateTotal = () => {
    if (!picpayData || !picpayData.installments) return transactionData.amount;
    
    const selectedOption = picpayData.installments.find(
      (opt) => opt.installmentCount === selectedInstallments
    );

    return selectedOption ? selectedOption.totalValue : transactionData.amount;
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      {/*
        challengeData e !paymentSuccess no guard: sem eles o modal continuava renderizado ao lado
        da tela de sucesso depois de um desafio aprovado, porque o `step` permanece "challenge"
        enquanto a cobranca acontece. Durante a autorizacao o challengeData ainda esta setado, que
        e o que mantem o spinner de "Confirmando autenticacao..." visivel.
      */}
      {step === "challenge" && challengeData && !paymentSuccess && (
        <div className="modal" style={{ width: "425px", position: "relative" }}>
          {!challengeCompleting && (
            <button
              className="close"
              onClick={() => {
                reportChallengeError("challenge_user_cancelled", {
                  username: transactionData.username,
                  token: transactionData.token,
                  merchantChargeId: challengeData?.sessionId || challengeData?.merchantChargeId,
                  chargeId: challengeData?.chargeId || "",
                  detail: "Usuário cancelou a autenticação do banco manualmente",
                });
                // Cancelamento manual nao e recusa: o comprador desistiu e pode tentar de novo.
                // Recusa e timeout, esses sim, encerram a compra (ver abort3ds).
                setErrorMessage("Autenticação cancelada. Você pode tentar novamente.");
                setChallengeData(null);
                setThreeDsContext(null);
                setStep("installments");
              }}
              style={{
                cursor: "pointer",
                position: "absolute",
                right: "-10px",
                top: "-10px",
                width: "36px",
                height: "36px",
                fontSize: "24px",
                background: "#D11A2A",
                borderRadius: "18px",
                border: "1px solid #cfcece",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                lineHeight: "normal",
                padding: 0,
              }}
            >
              ×
            </button>
          )}
          <h1 className="modal-title" style={{ fontSize: "1.3rem", marginBottom: "8px" }}>
            Autenticação do banco
          </h1>
          <p className="modal-subtext" style={{ fontSize: "0.9rem", textAlign: "center", marginTop: 0 }}>
            Complete a verificação solicitada pelo seu banco para confirmar o pagamento.
          </p>
          {challengeCompleting ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 0" }}>
              <ProgressSpinner style={{ width: "40px", height: "40px" }} strokeWidth="4" />
              <p style={{ marginTop: "16px", color: "#666", fontSize: "14px" }}>Confirmando autenticação...</p>
            </div>
          ) : (
            /* O enrollment devolve as dimensoes que o ACS espera; 400px e so fallback. */
            <iframe
              name="picpay-challenge-iframe"
              style={{ width: "100%", height: `${challengeData?.height || 400}px`, border: "1px solid #eee", borderRadius: "8px", marginTop: "8px" }}
              title="Autenticação 3DS"
              onError={() => {
                reportChallengeError("challenge_iframe_onerror", {
                  username: transactionData.username,
                  token: transactionData.token,
                  merchantChargeId: challengeData?.sessionId || challengeData?.merchantChargeId,
                  chargeId: challengeData?.chargeId,
                  detail: "Evento onError disparado no iframe do desafio 3DS",
                });
              }}
            />
          )}
        </div>
      )}
      {/*
        Autenticacao recusada ou expirada. Esta tentativa acabou -- cobrar sem autenticacao valida
        esta fora de questao, e o estado que esta implementacao corrige. O comprador pode tentar de
        novo (nova sessao, nova autenticacao), trocar de cartao ou sair. Com o cartao bloqueado, so
        trocar ou sair.
      */}
      {step === "3ds-rejected" && (
        <div className="modal" style={{ width: "425px" }}>
          <img className="logo" src={"/img/raidhut.png"} alt="raidhut-logo" />
          <h1 className="modal-title" style={{ fontSize: "1.3rem", marginBottom: "8px" }}>
            Autenticação não concluída
          </h1>
          <p
            className="modal-subtext"
            style={{ fontSize: "0.95rem", textAlign: "center", marginTop: 0 }}
          >
            {threeDsRejection}
          </p>
          <p style={{ fontSize: "0.85rem", color: "#666", textAlign: "center", marginTop: "8px" }}>
            Nenhuma cobrança foi feita no seu cartão.
          </p>
          {threeDsNotice && (
            <p style={{ fontSize: "0.85rem", color: "#9a6700", textAlign: "center", marginTop: "8px" }}>
              {threeDsNotice}
            </p>
          )}
          {!cardBlocked && (
            <button className="copy-button" onClick={retrySameCard} style={{ marginTop: "20px" }}>
              Tentar novamente
            </button>
          )}
          <button
            className="copy-button"
            onClick={chooseAnotherCard}
            style={{ marginTop: cardBlocked ? "20px" : "10px", background: "#f0f0f0", color: "#333" }}
          >
            Usar outro cartão
          </button>
          <button
            onClick={handleRedirect}
            style={{
              marginTop: "14px",
              background: "none",
              border: "none",
              color: "#666",
              textDecoration: "underline",
              cursor: "pointer",
              fontSize: "0.9rem",
            }}
          >
            Voltar para a loja
          </button>
        </div>
      )}

      {step === "cards" && renderCardSelection()}
      {step === "installments" && !paymentSuccess && (
        <InstallmentsPage
          installments={picpayData?.installments || []}
          onContinue={handleInstallmentsContinue}
          onCancel={() => { setStep(flowType === "otherCard" ? "cardForm" : "cards"); setErrorMessage(""); }}
          isLoading={isLoading || collecting3ds}
          loadingMessage={collecting3ds ? "Verificando autenticidade..." : undefined}
          // Em cartao novo o CVV ja foi digitado no formulario anterior; so a recompra precisa
          // pedir de novo, porque o endpoint de autorizacao 3DS o exige como obrigatorio.
          requireCvv={flowType === "savedCard"}
          errorMessage={errorMessage}
          noticeMessage={errorMessage ? cardNotice : ""}
          cardBlocked={cardBlocked}
          onChooseAnotherCard={chooseAnotherCard}
          onBackToStore={handleRedirect}
        />
      )}
      {step === "cardForm" && !paymentSuccess && (
        <CardFormPage
          checkoutData={{ ...transactionData, amount: calculateTotal() }}
          onSubmit={handleCardFormSubmit}
          isLoading={isLoading}
          onCancel={() => { setStep("cards"); setErrorMessage(""); }}
          onBack={() => { setStep("cards"); setErrorMessage(""); }}
          errorMessage={errorMessage}
        />
      )}
      {step === "addCard" && (
        <AddCardPage
          username={transactionData.username}
          token={transactionData.token}
          onSuccess={() => {
            fetchSavedCards();
            setStep("cards");
          }}
          onCancel={() => setStep("cards")}
          onIncompletePersonalInfo={onRequirePersonalInfo}
        />
      )}
      {paymentSuccess && (
        <SuccessPage
          receiptLink={receiptLink}
          paymentInfo={paymentInfo}
          onClose={handleRedirect}
        />
      )}
    </div>
  );
}